import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import HeroSection from "../components/HeroSection";
import InfoSection from "../components/InfoSection";
import ServicesSection from "../components/ServiceSection";
import {
  homeObjOne,
  homeObjThree,
  homeObjTwo,
} from "../components/InfoSection/Data";
import SignUp from "../components/SignUp";
import Proyectos from "../components/Proyectos/Proyectos";
import "react-toastify/dist/ReactToastify.css";

const Home = () => {
  const [isOpen, setIsopen] = useState(false);

  const toogle = () => {
    setIsopen(!isOpen);
  };

  const [currentLanguage, setCurrentLanguage] = useState("es");

  const handleLanguageChange = (newLanguage) => {
    setCurrentLanguage(newLanguage);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toogle={toogle} />
      <Navbar
        toogle={toogle}
        isOpen={isOpen}
        currentLanguage={currentLanguage}
        onChangeLanguage={handleLanguageChange}
      />
      <HeroSection />
      <InfoSection {...homeObjTwo} />
      <Proyectos />
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjOne} />
      <ServicesSection />
      <SignUp />
    </>
  );
};

export default Home;
